/**
 * HopSeat Analytics — Google Analytics 4 (G-QH9HNTBP04)
 *
 * Usage:
 *   import { trackEvent, trackDriverSignup, trackGigApply } from '../utils/analytics';
 */

const GA_ID = 'G-QH9HNTBP04';

/** Fire a GA4 event safely (no-ops if gtag not loaded) */
export function trackEvent(eventName, params = {}) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
}

/** Track a page view — called by the route-change watcher in App.js */
export function trackPageView(path, title) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', GA_ID, {
    page_path: path,
    page_title: title || document.title,
  });
}

// ── HopSeat-specific events ────────────────────────────────────────────────

/** New user registered */
export function trackSignup(role) {
  trackEvent('sign_up', { method: 'email', user_role: role });
}

/** User logged in */
export function trackLogin(role) {
  trackEvent('login', { method: 'email', user_role: role });
}

/** Driver applied to a gig */
export function trackGigApply(gigId, gigTitle) {
  trackEvent('gig_application', { gig_id: gigId, gig_title: gigTitle });
}

/** Bus company posted a new gig */
export function trackGigPosted(gigId) {
  trackEvent('gig_posted', { gig_id: gigId });
}

/** Driver submitted a service report */
export function trackServiceReport() {
  trackEvent('service_report_submitted');
}

/** User subscribed / upgraded plan */
export function trackSubscribe(planName, billingCycle) {
  trackEvent('purchase', {
    currency: 'USD',
    items: [{ item_name: planName, item_category: 'membership' }],
    billing_cycle: billingCycle,
  });
}

/** User redeemed points */
export function trackPointsRedeem(rewardType, points) {
  trackEvent('points_redeemed', { reward_type: rewardType, points_used: points });
}

/** Admin approved a driver */
export function trackDriverApproved() {
  trackEvent('driver_approved');
}

/** Pay dispute opened */
export function trackDisputeOpened() {
  trackEvent('dispute_opened');
}
